<script>

import { Line, mixins } from 'vue-chartjs'

export default Line.extend({
  mixins: [mixins.reactiveProp],
  props: {
    chartData: Object
  },
  data () {
    return {
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: 'transparent',
              zeroLineColor: 'transparent'
            },
            ticks: {
              fontSize: 2,
              fontColor: 'transparent'
            }
          }],
          yAxes: [{
            ticks: {
              min: 0,
              beginAtZero: true,
              callback: (value, index, values) => {
                if (Math.floor(value) === value) {
                  return value
                }
                return ''
              }
            }
          }]
        },
        elements: {
          line: {
            borderWidth: 1
          },
          point: {
            radius: 1,
            hitRadius: 4,
            hoverRadius: 4
          }
        }
      }
    }
  },
  methods: {
    refreshRenderChart () {
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    this.refreshRenderChart()
  }
})
</script>



// WEBPACK FOOTER //
// LineChart.vue?2e39feb1